export default "__VITE_ASSET__DZMXQCY0__"